import { render, staticRenderFns } from "./listCommande.vue?vue&type=template&id=625f3b10&"
import script from "./listCommande.vue?vue&type=script&lang=js&"
export * from "./listCommande.vue?vue&type=script&lang=js&"
import style0 from "./listCommande.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports